import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { provider } from '../../providers/provider';
import { TranslateService } from '@ngx-translate/core';
import { HomePage } from '../home/home';


@Component({
  selector: 'page-failure',
  templateUrl: 'failure.html',
})
export class Failure {
  message:any;
  GOTOhompage = HomePage;

  constructor(public navCtrl: NavController,public provider: provider,public storage: Storage,public navParams: NavParams,public translateService: TranslateService) {
    this.message = navParams.get('message');
  }

}



// WEBPACK FOOTER //
// ./src/pages/failure/failure.ts